import styled from "styled-components/macro";
import {useParams} from "react-router-dom";
import Header from "../../components/header";
import TopBar from "../../components/top_bar";
import SortBar from "../../components/sort_bar";
import CommunityHeader from "../../components/community_header";
import Container from "../../components/container";
import Main from '../../components/main';
import Sidebar from "../../components/sidebar";
import Footer from "../../components/footer";
import {useFeedback} from "../../store/feedback";
import {useQuery} from "../../utils/router";
import Wrapper from "../../components/wrapper";
import {useCommunityStyle} from "../../api/communities";
import {useBaseCommunity} from "../../store/hooks";
import {useSettings} from "../../store";
import PostList from "../../components/post_list";
import HeaderData from "../../components/header_data";
import Pagination from "../../components/pagination";
import Post from "../../components/post";
import Comment from "../../components/comment";
import {useSavedContent} from "../../api/content";
import {isPseudoCommunity} from "../../store/communites";
import useWindowDimensions from "../../utils/dimensions";
import LegacySortBar from "../../components/legacy/legacy_sort_bar";

const SavedFolder = styled(({className}) => {

    const {folder} = useParams();
    const community = useBaseCommunity();
    const style = useCommunityStyle(community);

    const loading = useFeedback();
    const page = parseInt(useQuery().page || '1');
    const {expand} = useSettings();
    const {content} = useSavedContent(loading.channel, folder, 'Win', page);

    const {width} = useWindowDimensions();

    return (
        <div className={className}>
            <HeaderData title={`Saved Posts`} community={community} community_style={style}/>
            <Header>
                {(community !== "TheDonald" || width <= 780) && <TopBar legacyConversion={community === "TheDonald"} page={'Saved Posts'}/>}
                {!isPseudoCommunity(community) &&
                    <>
                        <CommunityHeader community={community}/>
                    </>
                }
                {community === "TheDonald" && width > 780 && <LegacySortBar />}
            </Header>
            <SortBar community={community} />
            <Container>
                <Wrapper>
                    <Main>
                        {content?.map((content, index) => {
                            if (!content) {
                                // eslint-disable-next-line react/no-array-index-key
                                return <Post key={index}/>;
                            }
                            if ('comments' in content) {
                                return (
                                    <Post key={content.id} post={content} show_community={community === 'win' || community === 'all' || community === 'home' || community === 'trending'} expand={expand} />
                                );
                            }
                            return (
                                <Comment key={content.id} comment={content} showCommunity={community === 'win' || community === 'all' || community === 'home'} contextual hideComments postAuthor={content.post_author}/>
                            );
                        })}
                        {loading.busy && (
                            <PostList
                                initialExpand={expand}
                                loading
                            />
                        )}
                    </Main>
                    <Pagination path={`/saved/${folder}?page=`} has_more page={page} />
                </Wrapper>
                <Sidebar sidebar={style && style.sidebar} community={community} />
            </Container>
            <Footer />
        </div>
    );
})``;

export default SavedFolder;
